import { render, staticRenderFns } from "./BasicEducationCertificates.vue?vue&type=template&id=905a25c8&scoped=true"
import script from "./BasicEducationCertificates.vue?vue&type=script&lang=js"
export * from "./BasicEducationCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905a25c8",
  null
  
)

export default component.exports